<script>
export default {
  name: 'AnalyzeMarketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7933 1.33337H5.20666C2.77999 1.33337 1.33333 2.78004 1.33333 5.20671V10.7867C1.33333 13.22 2.77999 14.6667 5.20666 14.6667H10.7867C13.2133 14.6667 14.66 13.22 14.66 10.7934V5.20671C14.6667 2.78004 13.22 1.33337 10.7933 1.33337ZM6.60666 10.7934C6.60666 11.22 6.25999 11.5667 5.82666 11.5667C5.39999 11.5667 5.05333 11.22 5.05333 10.7934V8.62004C5.05333 8.19337 5.39999 7.84671 5.82666 7.84671C6.25999 7.84671 6.60666 8.19337 6.60666 8.62004V10.7934ZM10.9467 10.7934C10.9467 11.22 10.6 11.5667 10.1733 11.5667C9.74 11.5667 9.39333 11.22 9.39333 10.7934V5.20671C9.39333 4.78004 9.74 4.43337 10.1733 4.43337C10.6 4.43337 10.9467 4.78004 10.9467 5.20671V10.7934Z"
      :fill="color"
    />
  </svg>
</template>
